$(document).ready(function() {

    $('.language-change').on('click',function() {
        const lang = $(this).attr('data-lang');
        document.cookie = "lang="+lang+"; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        $.ajax({
                type: 'POST',
                url: '/settings',
                data: {'action':'change_lang','lang':lang},
                dataType: 'json',
            }).always(function(){
              window.location.reload();
            });
    });
    $('.theme-change').on('click',function() {
        const theme = $(this).attr('data-theme');
        document.cookie = "theme="+theme+"; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        $('html').attr('data-bs-theme',theme);
    });
    $('#menu_resize').on('click',function() {
        if($('#left-side').hasClass('narrow')) {
            $('#left-side').removeClass('narrow');
            document.cookie = "narrow=; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        }
        else {
            $('#left-side').addClass('narrow');
            document.cookie = "narrow=narrow; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        }

    });
    const menus9List = document.querySelectorAll('.menus-9');
        if (menus9List) {
          menus9List.forEach(e => {
            new Menu(e);
          });
        }

      const currentPath = window.location.pathname;
      $('#left-menu-side a').each(function() {
        const linkPath = this.pathname;
        if (linkPath === currentPath) {
           $(this).closest('li.menu-item').addClass('active');
        }
        if(currentPath.startsWith('/admin/')){
            $('.menu-group').addClass('active');
            $('#admin-collapse').addClass('show');
        }
      });

      $('#left-hamburger-menu').on('click',function(){
          if($('body').attr('data-menu')==='show'){
              $('body').attr('data-menu',null);
          }
          else {
              $('body').attr('data-menu','show');
          }
      });

      function checkWidth() {
          const leftSide = document.getElementById("left-side");
          if (window.innerWidth < 768) {
            leftSide.classList.add("narrow");
           }
          // else {
          //   leftSide.classList.remove("narrow");
          // }
        }

        checkWidth();
        window.addEventListener("resize", checkWidth);
});

const templateName = 'Vuexy';
const layout= 'vertical';
const mode= 'light';
const direction= 'ltr';
const skin= 'default';
const contentWidth= 'boxed';
const footer= 'static';
const routingLoader= true;
const navHidden= false;
const menuTextTruncate= true;
const navSubItemIcon= 'tabler=circle';
const verticalNavToggleType= 'accordion';
const navCollapsed= false;
const navigationSize= 260;
const collapsedNavigationSize= 82;
const afterVerticalNavMenuContentPosition= 'fixed';
const beforeVerticalNavMenuContentPosition= 'fixed';
const horizontalMenuToggle= 'hover';
const horizontalMenuAnimation= true;
const appBar= 'fixed';
const appBarBlur= true;
const responsiveFontSizes= true;
const disableRipple= false;
const disableCustomizer= false;
const toastPosition= 'top-right'

